export default __webpack_public_path__ + "static/media/avatar_mice8.e7ddb06c.mp3";